// DataContext.js
import React, {createContext, useState, useEffect, useContext} from 'react';
import { fetchAllGUIInstruments } from '../services/GUIInstrumentService';
import { startKiteWebSocket } from '../services/kiteWebSocketStarterService';
import {getTabList, saveArrayToFile, updateTickerSubscriptionWithKite} from '../services/apiService';
import WebSocketService from "../../websockets/WebSocketService";
import {LoginContext} from "../../../LoginContext";
import {normalizeBroadcastTime} from "@dashboard/services/AnnouncementService";
import {assignPFSymbols, pfSymbolsRef} from "@dashboard/shared/pfSymbolsRef";
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [allInstrumentsList, setAllInstrumentsList] = useState([]);  // State for new Instruments
    const [allExchangeInstruments, setAllExchangeInstruments] = useState([]);
    const [tabList, setTabList] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);  // Track user login status
    const [isDataContextLoaded, setIsDataContextLoaded] = useState(false);  // New state to track if data is loaded
    const { handleLoginFunction } = useContext(LoginContext);  // Correctly destructuring the login function
    const [screenerURLs, setScreenerURLs] = useState({}); // State for storing tradingsymbol to screenerUrl map
    const [initialSymbolToAnnouncementsMap, setInitialSymbolToAnnouncementsMap] = useState({});
    const { zerodhaConnectionStatusDTO } = useContext(LoginContext);
    const [initialSymbolToBSEAnnouncementsMap, setInitialSymbolToBSEAnnouncementsMap] = useState({});
    const [initialSymbolToNSEAnnouncementsMap, setInitialSymbolToNSEAnnouncementsMap] = useState({});

    const load_allInstrumentsListFromFile = async () => {
        try {
            console.log('Executing load_allInstrumentsListFromFile');

            const res = await fetch('/api/all-instruments/load');
            const data = await res.json();

            setAllInstrumentsList(data.instruments || []);
            setAllExchangeInstruments(data.allExchangeInstruments || []);

            console.log(
                'Loaded instruments:',
                data.instruments?.length,
                'exchange instruments:',
                data.allExchangeInstruments?.length
            );
        } catch (error) {
            console.error('Error loading instruments from backend:', error);
        }
    };


    const load_all_exchange_Announcements = async () => {
        try {
            const res = await fetch('/api/announcements/all');
            const data = await res.json();

            setInitialSymbolToBSEAnnouncementsMap(data.bse || {});
            setInitialSymbolToNSEAnnouncementsMap(data.nse || {});

            console.log("Loaded BSE + NSE announcements separately.");
        } catch (error) {
            console.error("Failed to load announcements:", error);
        }
    };

    const reloadScreenerURLs = async () => {
        try {
            console.log('Reloading Screener URLs...');
            const res = await fetch('/screener-urls');
            const data = await res.json();
            setScreenerURLs(data);
            //console.log('Screener URLs reloaded:', response.data);
        } catch (error) {
            console.error('Error fetching screener URLs:', error);
        }
    };

    const loadDistinctGroupSymbols = async () => {
        try {
            console.log("Loading distinct Group symbols…");
            const res = await fetch('/api/portfolio-export/group/distinct-symbols');
            const data = await res.json();
            assignPFSymbols(data);
            console.log("Loaded Group symbols:", pfSymbolsRef.current.length);
        } catch (err) {
            console.error("Failed to load distinct Group symbols:", err);
            pfSymbolsRef.current = [];
        }
    };


    const handleLoginSuccess = () => {
        setIsLoggedIn(true);  // Update login status when the user logs in
    };

    useEffect(() => {
        const init = async () => {
            
            try {
                console.log("loadData execution started");

                await load_all_exchange_Announcements();
                await load_allInstrumentsListFromFile();
                await loadDistinctGroupSymbols(); // <-- here we call it

                const tabResponse = await getTabList();
                setTabList(tabResponse);

                //await startKiteWebSocket();

                await reloadScreenerURLs();

                WebSocketService.subscribe('reloadInstruments', null, load_allInstrumentsListFromFile);
                WebSocketService.subscribe('reloadScreenerUrls', null, reloadScreenerURLs);

                setIsDataContextLoaded(true);
                console.log("setIsDataContextLoaded set to true");
            } catch (err) {
                console.error("❌ Error during datacontext loading:", err);
            }
        };

        init();
    }, []);

    return (
        <DataContext.Provider value={{
            tabList,
            allInstrumentsList,
            allExchangeInstruments,
            handleLoginSuccess,
            isLoggedIn,
            isDataContextLoaded,
            screenerURLs,
            initialSymbolToBSEAnnouncementsMap,
            setInitialSymbolToBSEAnnouncementsMap,
            initialSymbolToNSEAnnouncementsMap,
            setInitialSymbolToNSEAnnouncementsMap
        }}>
        {children}
        </DataContext.Provider>
    );
};
